import "../styles/createpost.css";
import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles
import { db } from "../firebase-config";
import { collection, addDoc, doc, getDoc } from "firebase/firestore";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const CreatePost = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState(""); // Rich text content
  const [error, setError] = useState("");
  const { user } = useContext(AuthContext);
  const [userInfo, setUserInfo] = useState({});

  // Toolbar configuration
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }], // Headers and fonts
      [{ size: [] }], // Font size
      ["bold", "italic", "underline", "strike"], // Formatting buttons
      [{ color: [] }, { background: [] }], // Text and background colors
      [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      ["link"], // Links
      ["clean"], // Remove formatting
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "link",
  ];

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (user && user.uid) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            setUserInfo(userDoc.data());
          }
        } catch (err) {
          console.error("Error fetching user info:", err);
        }
      }
    };
    fetchUserInfo();
  }, [user]);

  const handlePost = async (e) => {
    e.preventDefault();

    if (!user || !user.uid) {
      setError("You must be logged in to create a post.");
      return;
    }

    if (!title.trim() || !content.trim()) {
      setError("Title and content cannot be empty.");
      return;
    }

    try {
      await addDoc(collection(db, "posts"), {
        title,
        content, // Save the rich text HTML content
        userId: user.uid,
        username: userInfo.username || "",
        displayName: userInfo.displayName || "",
        photoURL: userInfo.photoURL || "",
        createdAt: new Date(),
      });

      alert("Post created successfully!");
      setTitle("");
      setContent(""); // Clear editor
      setError("");
    } catch (err) {
      console.error("Error creating post:", err);
      setError("Error creating post: " + err.message);
    }
  };

  return (
    <div className="form-container">
      <h1>Create a New Post</h1>
      <form onSubmit={handlePost}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <ReactQuill
          value={content}
          onChange={setContent}
          modules={modules} // Apply custom toolbar configuration
          formats={formats} // Apply custom formats
          placeholder="Write your post content here..."
        />
        <button type="submit">Submit Post</button>
      </form>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default CreatePost;
